import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, ChevronDownIcon, ChevronUpIcon, FacebookIcon, InstagramIcon, MailIcon, ShieldCheckIcon, XCircleIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://megapack-maderoterapia-pro.impultienda.ar/checkout';
const faqs = [['¿Sirve si soy principiante en maderoterapia?', 'Sí. El Tomo 1 empieza desde los fundamentos: anatomía, herramientas y protocolo base. No necesitas experiencia previa para entender y aplicar el material.'], ['¿Cómo recibo el material?', 'Descarga inmediata en PDF apenas confirmas la compra. Lo abres en computadora, tablet o celular, y puedes imprimir todo lo que necesites.'], ['¿Sirve si ya hago masajes o trabajo en estética?', 'Especialmente. El MegaPack está diseñado para cualquier profesional del bienestar que quiera agregar o mejorar la maderoterapia como servicio diferenciador.'], ['¿Es un curso con clases en video?', 'No. Es material listo para usar en formato PDF. Sin videos largos ni plataformas: abres el tomo, eliges el protocolo y lo aplicas.'], ['¿Puedo usar las fichas y plantillas con mis clientes?', 'Sí. Las fichas, consentimientos y material entregable están diseñados para usar directamente con tus clientes. Puedes personalizarlos con tu nombre o logo.'], ['¿Sirve si quiero empezar a vender sesiones desde cero?', 'Sí. La Agenda 21 Días y los guiones de WhatsApp e Instagram te ayudan a pasar de cero a tener tu servicio organizado y comunicado.'], ['¿Y si no me sirve?', 'Tienes garantía de 7 días con devolución total, sin preguntas.']];
const kitRows = [['El cliente pregunta cuánto cuesta', 'Cobras por sesión suelta y el cliente compara', 'Vendes un programa cerrado con nombre y resultado'], ['El cliente termina la primera sesión', 'Decide si vuelve o no', 'Ya compró un paquete de 4 u 8 sesiones'], ['Necesitas más ingresos', 'Tu único camino es más horas', 'Sesiones grupales: mismo protocolo, 4–6 personas'], ['Vender tu servicio', 'Explicas qué es la maderoterapia', 'Muestras una página de presentación profesional'], ['Ponerle precio', 'Adivinas mirando a otros terapeutas', 'Guía de precios con valores reales por país']];
const costRows = [['Buscar protocolos antes de cada sesión', '2+ horas semanales de trabajo no pago'], ['No tener un menú de servicios claro', 'Cobras menos de lo que vale tu trabajo'], ['Cliente que no ve resultados documentados', 'Abandona después de 2 sesiones — pierdes $40–150 por cliente'], ['Sesiones sin estructura definida', 'Tu imagen profesional en juego en cada improvisación'], ['No saber cómo ofrecer paquetes', 'Sigues cobrando por sesión suelta sin escalar'], ['Herramientas sin protocolo claro', 'Usas siempre las mismas 2 y dejas el kit sin aprovechar']];
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 34
  });
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        if (current.seconds) return {
          ...current,
          seconds: current.seconds - 1
        };
        if (current.minutes) return {
          ...current,
          minutes: current.minutes - 1,
          seconds: 59
        };
        if (current.hours) return {
          hours: current.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return current;
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const clock = `${String(timeLeft.hours).padStart(2, '0')}:${String(timeLeft.minutes).padStart(2, '0')}:${String(timeLeft.seconds).padStart(2, '0')}`;
  return <div className="w-full bg-cream" data-id="element-110">
      <section className="bg-brand-900 px-4 py-11 text-center text-white sm:px-6" data-id="element-111">
        <p className="text-xs font-black tracking-[0.12em] text-accent" data-id="element-112">
          PRECIO DE LANZAMIENTO — CIERRA EN:
        </p>
        <p aria-live="polite" className="mt-3 font-mono text-4xl font-black tracking-tight text-white sm:text-6xl" data-id="element-113">
          {clock}
        </p>
        <p className="mt-3 text-sm text-gray-300" data-id="element-114">
          Después sube a $47. No vuelve.
        </p>
        <div className="mx-auto mt-5 h-2 max-w-md overflow-hidden rounded-full bg-brand-800" data-id="element-115">
          <div className="h-full w-[84%] rounded-full bg-accent" data-id="element-116" />
        </div>
        <p className="mt-2 text-xs text-brand-100" data-id="element-117">
          84% de los cupos al precio de lanzamiento ya reservados
        </p>
      </section>

      <section id="pricing" className="mx-auto max-w-6xl scroll-mt-4 px-4 py-12 sm:px-6 md:py-20" data-id="element-118">
        <div className="text-center" data-id="element-119">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-120">
            Elige tu MegaPack
          </p>
          <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-121">
            Todo lo que necesitas para trabajar con sistema
          </h2>
        </div>
        <div className="mx-auto mt-9 max-w-2xl" data-id="element-122">
          <article className="flex flex-col rounded-2xl border border-brand-100 bg-white p-6 text-center shadow-sm md:p-8" data-id="element-123">
            <p className="text-xs font-black tracking-[0.14em] text-brand-600" data-id="element-124">
              MEGAPACK MADEROTERAPIA PRO
            </p>
            <h3 className="mt-2 text-2xl font-black text-brand-900" data-id="element-125">
              MEGAPACK MADEROTERAPIA PRO
            </h3>
            <p className="mt-2 text-sm text-gray-600" data-id="element-126">
              6 Tomos + 5 Bonos — Todos tus protocolos resueltos.
            </p>
            <p className="mt-6" data-id="element-127">
              <span className="mr-2 text-lg text-gray-400 line-through" data-id="element-128">
                $43
              </span>
              <strong className="text-4xl font-black text-brand-900" data-id="element-129">
                $19
              </strong>{' '}
              <span className="font-bold text-brand-600" data-id="element-130">USD</span>
            </p>
            <ul className="mt-6 space-y-3 text-sm text-gray-700" data-id="element-131">
              {['6 tomos completos con 300+ páginas', '5 bonos estratégicos incluidos', 'Protocolos, fichas y checklists imprimibles'].map(item => <li key={item} className="flex gap-2" data-id="element-132">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-500" data-id="element-133" />
                  {item}
                </li>)}
            </ul>
            <a href={CHECKOUT_URL} className="mt-8 block rounded-xl border-2 border-brand-600 px-4 py-3.5 text-center text-sm font-extrabold text-brand-700 transition-colors hover:bg-brand-50" data-id="element-134">
              QUIERO MI MEGAPACK — $19 USD
            </a>
          </article>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-20" data-id="element-135">
        <h2 className="text-center text-3xl font-black text-brand-900" data-id="element-136">
          Más profesionales, más confianza
        </h2>
        <div className="mt-9 grid gap-4 sm:grid-cols-2 md:grid-cols-3" data-id="element-137">
          {['El Tomo 2 es oro. En 2 minutos tenía el protocolo exacto con orden de herramientas y tiempos.', 'Vendí mi primer paquete de 8 sesiones a $280 USD usando la plantilla del Kit Negocio.', 'Los guiones de WhatsApp hicieron que responder el precio ya no me genere ansiedad.', 'El bono de fichas le dio a mi servicio una imagen de clínica profesional.', 'El protocolo post-parto me permitió cobrar el doble que una sesión reductora normal.', 'Antes improvisaba cada sesión. Ahora trabajo con mi cronograma frente a mí y mucha más confianza.'].map((quote, index) => <article key={quote} className="rounded-xl border border-brand-100 bg-white p-5" data-id="element-138">
              <p className="text-xs font-bold text-accent" data-id="element-139">★★★★★</p>
              <blockquote className="mt-2 text-sm leading-relaxed text-gray-700" data-id="element-140">
                “{quote}”
              </blockquote>
              <p className="mt-4 text-xs font-bold text-brand-700" data-id="element-141">
                {['Maderoterapista certificada, Argentina', 'Terapeuta corporal, México', 'Emprendedora wellness, España', 'Instructora de pilates, Colombia', 'Terapeuta manual, Chile', 'Masajista wellness, Uruguay'][index]}
              </p>
            </article>)}
        </div>
      </section>

      <section className="bg-brand-50 px-4 py-12 sm:px-6" data-id="element-142">
        <div className="mx-auto max-w-3xl rounded-3xl border-2 border-brand-100 bg-white p-7 text-center shadow-sm md:p-10" data-id="element-143">
          <ShieldCheckIcon className="mx-auto h-12 w-12 text-brand-600" data-id="element-144" />
          <h2 className="mt-4 text-3xl font-black text-brand-900" data-id="element-145">
            GARANTÍA DE 7 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="mt-4 leading-relaxed text-gray-600" data-id="element-146">
            Abre los tomos. Úsalos en tus sesiones reales. Si en 7 días no es lo
            que esperabas, te devolvemos el 100%, sin formularios y sin
            complicaciones.
          </p>
          <p className="mt-5 text-sm font-bold text-brand-600" data-id="element-147">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </section>

      <section className="bg-white px-4 py-12 sm:px-6 md:py-20" data-id="element-148">
        <div className="mx-auto max-w-3xl" data-id="element-149">
          <h2 className="text-center text-3xl font-black text-brand-900" data-id="element-150">
            Preguntas frecuentes
          </h2>
          <div className="mt-8 space-y-3" data-id="element-151">
            {faqs.map(([question, answer], index) => {
            const isOpen = openFaq === index;
            return <div key={question} className="overflow-hidden rounded-xl border border-gray-200" data-id="element-152">
                  <button type="button" onClick={() => setOpenFaq(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 bg-cream px-5 py-4 text-left text-sm font-bold text-brand-900" data-id="element-153">
                    {question}
                    {isOpen ? <ChevronUpIcon className="h-5 w-5 shrink-0" data-id="element-154" /> : <ChevronDownIcon className="h-5 w-5 shrink-0" data-id="element-155" />}
                  </button>
                  {isOpen && <div className="bg-white px-5 py-4 text-sm leading-relaxed text-gray-600" data-id="element-156">
                      {answer}
                    </div>}
                </div>;
          })}
          </div>
        </div>
      </section>

      <section className="bg-brand-900 px-4 py-12 text-white sm:px-6 md:py-20" data-id="element-157">
        <div className="mx-auto max-w-6xl text-center" data-id="element-158">
          <h2 className="text-3xl font-black md:text-4xl" data-id="element-159">
            ¿Cuánto cuesta seguir improvisando?
          </h2>
          <p className="mt-4 text-brand-100" data-id="element-160">
            Tu próxima cliente puede vivir algo completamente diferente.
          </p>
          <div className="mt-8 overflow-x-auto rounded-xl border border-brand-700 text-left" data-id="element-161">
            <table className="min-w-[650px] w-full text-sm" data-id="element-162">
              <thead data-id="element-163">
                <tr className="bg-brand-800" data-id="element-164">
                  <th className="p-4" data-id="element-165">Sin MegaPack</th>
                  <th className="p-4" data-id="element-166">Costo real</th>
                </tr>
              </thead>
              <tbody data-id="element-167">
                {costRows.map(([without, cost]) => <tr key={without} className="border-t border-brand-700" data-id="element-168">
                    <td className="p-4 text-brand-100" data-id="element-169">{without}</td>
                    <td className="p-4 font-semibold text-white" data-id="element-170">{cost}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <p className="mt-10 font-serif text-2xl italic text-accent" data-id="element-171">
            “Tu próxima sesión puede ser la más profesional que hayas dado.”
          </p>
          <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-white p-7 text-brand-900 md:p-10" data-id="element-172">
            <h3 className="text-3xl font-black" data-id="element-173">
              Deja de improvisar. Empieza a trabajar con un sistema.
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-gray-600" data-id="element-174">
              Únete a profesionales del bienestar que ya dan sesiones con
              protocolo claro, clientes que vuelven y un servicio que se percibe
              como premium.
            </p>
            <div className="mt-6 grid gap-3 border-y border-brand-100 py-5 text-left text-sm sm:grid-cols-2" data-id="element-175">
              {['Tus 300 páginas de protocolos disponibles', 'Método probado, zona por zona', 'Programas con seguimiento documentado', 'Paquetes y programas cerrados', 'Cada herramienta con función exacta', 'Imagen profesional desde el primer contacto'].map(item => <span key={item} className="flex gap-2 font-semibold" data-id="element-176">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-500" data-id="element-177" />
                  {item}
                </span>)}
            </div>
            <p className="mt-6 text-xs font-bold tracking-wider text-brand-600" data-id="element-178">
              EL PRECIO CIERRA EN: {clock}
            </p>
            <p className="mt-2 text-sm font-bold" data-id="element-179">
              MEGAPACK MADEROTERAPIA PRO — $19 USD
            </p>
            <a href={CHECKOUT_URL} className="mt-6 block rounded-xl bg-brand-600 px-5 py-4 text-sm font-extrabold text-white transition-colors hover:bg-brand-700" data-id="element-180">
              SÍ, QUIERO MI MEGAPACK MADEROTERAPIA PRO
            </a>
            <p className="mt-4 text-xs text-gray-500" data-id="element-181">
              Pago 100% seguro · Acceso inmediato · Garantía de 7 días
            </p>
          </div>
        </div>
      </section>

      <footer className="bg-[#102015] px-4 py-10 text-center text-sm text-gray-400 sm:px-6" data-id="element-182">
        <div className="mx-auto max-w-4xl" data-id="element-183">
          <p className="font-bold text-white" data-id="element-184">MEGAPACK MADEROTERAPIA PRO™</p>
          <p className="mx-auto mt-3 max-w-xl leading-relaxed" data-id="element-185">
            El sistema más completo de protocolos listos para profesionales de
            la maderoterapia de habla hispana. Porque trabajar con el cuerpo de
            tus clientes no debería empezar con dudas la noche anterior.
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-186">
            <a href="mailto:tuproximonivel216@gmail.com" className="flex items-center gap-2 hover:text-white" data-id="element-187">
              <MailIcon className="h-4 w-4" data-id="element-188" />
              tuproximonivel216@gmail.com
            </a>
            <a href="https://www.instagram.com/tuproximonivel216/" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white" data-id="element-189">
              <InstagramIcon className="h-4 w-4" data-id="element-190" />
              Instagram
            </a>
            <a href="https://www.facebook.com/profile.php?id=61555374626740" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white" data-id="element-191">
              <FacebookIcon className="h-4 w-4" data-id="element-192" />
              Facebook
            </a>
          </div>
        </div>
      </footer>
    </div>;
}